import { useCallback, useEffect } from 'react'

import type { SoundId } from '@/src/game/audio/sounds'
import { store } from '@/src/stores/store'
import {
    playSound as playSoundUtil,
    playSoundUntilFinished as playSoundUntilFinishedUtil,
    playSoundWithVolume as playSoundWithVolumeUtil,
    soundPlayer,
} from '@/src/utils/soundPlayer'

/**
 * Bootstraps audio unlock + keeps Howler mute state in sync with settings.
 * Call once near the app root.
 */
export function useSoundSystem(): void {
    useEffect(() => {
        soundPlayer.init()
    }, [])

    useEffect(() => {
        soundPlayer.setMuted(!store.soundEnabled)
    }, [store.soundEnabled])
}

export function useSound() {
    const playSound = useCallback((soundId: SoundId) => {
        return playSoundUtil(soundId)
    }, [])

    const playSoundWithVolume = useCallback((soundId: SoundId, volume: number) => {
        return playSoundWithVolumeUtil(soundId, volume)
    }, [])

    const playSoundUntilFinished = useCallback(
        (soundId: SoundId, volume?: number) => {
            return playSoundUntilFinishedUtil(soundId, volume)
        },
        [],
    )

    return {
        playSound,
        playSoundWithVolume,
        playSoundUntilFinished,
        soundEnabled: store.soundEnabled,
    }
}
